import FlumpLibrary from "../FlumpLibrary";

/**
 * TODO - Add description.
 */
export default class FlumpSprite extends Phaser.Image
{
    /**
     * @param {Phaser.Game} game - A reference to the currently running game.
     * @param {FlumpLibrary} flumpLibrary 
     * @param {string} symbolName - Name of texture.
     * @param {number} x - X Position.
     * @param {number} y - Y Position.
     */
   constructor(game, flumpLibrary, symbolName, x, y)
   {
       super(game, x, y, symbolName);
       
       this.flumpLibrary = flumpLibrary;
       /** @type {string} */
       this.currentSprite = symbolName;
       
       /** @type {number} */
       this.skewX = 0;
       /** @type {number} */
       this.skewY = 0;
       this.name = "FlumpSprite";
       
       this.changeFrame(this.currentSprite);
   }

    /**
     * Cleans up the FlumpSprite.
     * @param {boolean} [destroyChildren=true] Defaulfs to true
     */
   destroy(destroyChildren = true)
   {
       this.flumpLibrary = null;
       super.destroy(destroyChildren);
   }
   
   /**
    * Change the texture for this sprite.
    * @param {string} symbolName - New sprite.
    */
   changeFrame(symbolName)
   {
       if(this.currentSprite == symbolName)
       {
           return;
       }
       
       this.currentSprite = symbolName;
       
       if(this.currentSprite != null)
       {
           var spriteOptions = this.flumpLibrary.getSprite(this.currentSprite);

           // console.log(this.currentSprite);
           this.loadTexture(spriteOptions.atlas);
           // console.log(this);

           this.crop(spriteOptions.rectangle);
           this.visible = true;
       }
       else
       {
           this.visible = false;
       }
   }
   
   /** @internal */
   updateTransform(parent)
   {        
       if (!parent && !this.parent && !this.game)
       {
           return;
       }

       var p = this.parent;

       if (parent)
       {
           p = parent;
       }
       else if (!this.parent)
       {
           p = this.game.world;
       }

       // create some matrix refs for easy access
       var pt = p.worldTransform;
       var wt = this.worldTransform;

       // temporary matrix variables
       var a, b, c, d, tx, ty;

       // so if rotation is between 0 then we can simplify the multiplication process..
       if (this.rotation % PIXI.PI_2 || this.skewX || this.skewY)
       {
           // check to see if the rotation is the same as the previous render. This means we only need to use sin and cos when rotation actually changes
           // if (this.rotation !== this.rotationCache)
           // {
           //     this.rotationCache = this.rotation;
           //     this._sr = Math.sin(this.rotation);
           //     this._cr = Math.cos(this.rotation);
           // }

           // get the matrix values of the displayobject based on its transform properties..
           a  =  this.scale.x * Math.cos(this.rotation + this.skewY);        
           b  =  this.scale.x * Math.sin(this.rotation + this.skewY);
           c  =  this.scale.y * Math.sin(-this.rotation - this.skewX);        
           d  =  this.scale.y * Math.cos(this.rotation + this.skewX);
           tx =  this.position.x;
           ty =  this.position.y;
           
           // check for pivot.. not often used so geared towards that fact!
           if (this.pivot.x || this.pivot.y)
           {
               tx -= this.pivot.x * a + this.pivot.y * c;
               ty -= this.pivot.x * b + this.pivot.y * d;
           }

           // concat the parent matrix with the objects transform.
           wt.a  = a  * pt.a + b  * pt.c;
           wt.b  = a  * pt.b + b  * pt.d;
           wt.c  = c  * pt.a + d  * pt.c;
           wt.d  = c  * pt.b + d  * pt.d;
           wt.tx = tx * pt.a + ty * pt.c + pt.tx;
           wt.ty = tx * pt.b + ty * pt.d + pt.ty;
       }
       else
       {
           // lets do the fast version as we know there is no rotation..
           a  = this.scale.x;
           d  = this.scale.y;

           tx = this.position.x - this.pivot.x * a;
           ty = this.position.y - this.pivot.y * d;

           wt.a  = a  * pt.a;
           wt.b  = a  * pt.b;
           wt.c  = d  * pt.c;
           wt.d  = d  * pt.d;
           wt.tx = tx * pt.a + ty * pt.c + pt.tx;
           wt.ty = tx * pt.b + ty * pt.d + pt.ty;
       }

       // multiply the alphas..
       /** @ignore */
       this.worldAlpha = this.alpha * p.worldAlpha;

       this.worldPosition.set(wt.tx, wt.ty);
       this.worldScale.set(Math.sqrt(wt.a * wt.a + wt.b * wt.b), Math.sqrt(wt.c * wt.c + wt.d * wt.d));
       /** @ignore */
       this.worldRotation = Math.atan2(-wt.c, wt.d);

       // reset the bounds each time this is called!
       this._currentBounds = null;

       //  Custom callback?
       if (this.transformCallback)
       {
           this.transformCallback.call(this.transformCallbackContext, wt, pt);
       }
   }
}